import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import type {Datapoint} from '@deviceinsight/ng-ui-api-client';
import {PaginationSettings, ReactableWithClientSidePagination} from '@deviceinsight/ng-ui-components';
import {getColumnDefs} from '../columnDefs/datapoints';
import {useTranslation} from '@deviceinsight/ng-ui-scale-lib/api';

type Props = {
	datapoints: Array<Datapoint> | null | undefined;
	isFetchingDatapoints: boolean;
	onSelectDatapoint: (arg0: Datapoint) => any;
	availableDataTypes?: Array<string>;
};
const initialPaginationSettings: PaginationSettings = {
	page: 0,
	size: 10,
	sort: {
		property: 'name',
		direction: 'ASC'
	}
};

const DatapointSelectionTable = ({onSelectDatapoint, availableDataTypes, datapoints, isFetchingDatapoints}: Props) => {
	const {t} = useTranslation();
	const columnDefs = getColumnDefs(t, onSelectDatapoint, '*', availableDataTypes);
	return (
		<div>
			<h2>
				<Trans i18nKey="rules.singleDatapointSelectionTableTitle">Please select a Datapoint...</Trans>
			</h2>
			<ReactableWithClientSidePagination
				columnDefs={columnDefs}
				uniqueItemKey={(dp) => dp.name}
				paginationSettings={initialPaginationSettings}
				items={datapoints}
				isLoading={isFetchingDatapoints}
			/>
		</div>
	);
};

export default DatapointSelectionTable;
